import React from 'react';

import StepsToJoinCampaign, {
  getStepsToJoinCampaign,
  JOIN_CAMPAIGN_STEP_TYPE,
  StepsToJoinCampaignStep,
} from '../StepsToJoinCampaign';
import { STATBULL_STORY_URLS } from './data';

const stepsToJoinStabullCampaign: StepsToJoinCampaignStep[] = [
  ...getStepsToJoinCampaign([
    JOIN_CAMPAIGN_STEP_TYPE.REGISTER_MAGIC_STORE_ACCOUNT,
    JOIN_CAMPAIGN_STEP_TYPE.ADD_EVM_WALLET,
    JOIN_CAMPAIGN_STEP_TYPE.USERNAME_AND_EMAIL,
  ]),
  {
    id: 'proof',
    title: 'Complete Proof-of-Humanity verification',
    type: JOIN_CAMPAIGN_STEP_TYPE.VERIFY_HUMANITY,
  },
  ...getStepsToJoinCampaign([
    JOIN_CAMPAIGN_STEP_TYPE.VISIT_CAMPAIGN_PAGE,
    JOIN_CAMPAIGN_STEP_TYPE.MONITOR_LEADERBOARD,
  ]),
  {
    id: 'claim',
    title: 'Rewards will be claimed through the Magic Launchpad / Presail',
  },
];

const StepToJoinStabullCampaign = () => {
  return (
    <StepsToJoinCampaign
      campaignUrl={STATBULL_STORY_URLS.campaign}
      steps={stepsToJoinStabullCampaign}
      className="story-prose-none"
    />
  );
};

export default StepToJoinStabullCampaign;
